import React, { useEffect } from 'react'
import CustomModal from '../../baseComponents/gui/customModal/CustomModal'
import { useModal } from '../../../hooks/useModal'
import Back from '../../features/back/Back'
import { safeHTML } from '../../../utils/safeHTML'
import Icon from '../../baseComponents/gui/icon/Icon'
import { useBackgroundData } from '../../../hooks/useBackgroundData'
import { useCountsData } from '../../../hooks/useCountsData'
import { GTMFriendReaction } from '../../../constants/analytics/GTM'
import { useRequestsHandlerData } from '../../../hooks/useRequestsHandlerData'
import AppLoader from '../../features/appLoader/AppLoader'
import { useActivePremiumAchievementIcon } from '../../../hooks/shared/achievements/useActivePremiumAchievementIcon'
import CustomButton from '../../features/customButton/ui/main/CustomButton'
import { useApplicationCallbacks } from '../../../providers/application-callbacks'
import { useContent } from '../../../redux/reducer/content'
import Room from '../../features/room/Room'
import MyId from '../../features/myId/MyId'
import { useRequests } from '../../../redux/reducer/requests'

const ProfileModal = React.forwardRef(function ({ buttons = [] }, ref) {
  const { state, viewedFriend } = useContent()
  const callbacks = useApplicationCallbacks()
  const { id, closeModal } = useModal()
  const {
    authData: { isWeb },
  } = useRequests()
  const counts = useCountsData(viewedFriend)
  const friendItems = useBackgroundData({
    items: viewedFriend?.items,
    extraRoom: viewedFriend?.eventRoomId,
  })
  const iconImage = useActivePremiumAchievementIcon({ extraPremiumIcon: viewedFriend?.iconId })

  const setReaction = (clickData) => {
    const reactionCallback =
      callbacks[`set${viewedFriend?.isLiked === clickData ? 'Dislike' : 'Like'}`]
    reactionCallback({ uid: viewedFriend?.uid, type: clickData })
  }

  const isPending = useRequestsHandlerData([
    { address: 'requestsUserSetDislike' },
    { address: 'requestsUserSetLike' },
  ])

  useEffect(() => () => callbacks.setIsVisible(false), [])

  return (
    <CustomModal isFullPage={true}>
      <div
        className={`profile-modal profile-modal_${state}`}
        ref={ref}
      >
        <div className={'profile-modal__bg'}>
          <Room
            clothItems={viewedFriend?.items}
            roomItems={friendItems}
            callbacks={callbacks}
          />
        </div>
        <div className={'profile-modal__content'}>
          <div className={`profile-modal__head ${isWeb ? '' : 'app'}`}>
            <Back onClick={() => closeModal(id)} />
            <div className={`profile-modal__name ${isWeb ? '' : 'app'}`}>
              {safeHTML(viewedFriend?.username)}
              {iconImage && (
                <img
                  src={iconImage}
                  className={'profile-modal__icon'}
                  alt={''}
                />
              )}
            </div>
            <div className={'profile-modal__info'}>
              <div className={'profile-modal__space'} />
              <div className={'profile-modal__id'}>
                <MyId id={viewedFriend?.uid} />
              </div>
            </div>
          </div>
          <div className={'profile-modal__footer'}>
            <div className={'profile-modal__counts'}>
              {counts?.map(({ icon, index, clickData }, i) => (
                <div
                  key={`reaction-${i}`}
                  className={'profile-modal__count-item'}
                  onClick={() => (setReaction(clickData), GTMFriendReaction())}
                >
                  <Icon name={icon} />
                  <span>{index}</span>
                </div>
              ))}
            </div>
            {!!buttons?.length && (
              <div className={'profile-modal__buttons'}>
                {buttons?.map((item, index) => (
                  <CustomButton
                    key={index}
                    {...item}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
        {isPending && <AppLoader />}
      </div>
    </CustomModal>
  )
})
export default ProfileModal
ProfileModal.propTypes = {}
